var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6928 0C17.7711 0.0619009 17.919 0.0279309 18.0251 0.0324603C26.5985 0.403866 33.7963 7.55192 33.9923 15.9176C34.0023 16.3456 34.0023 16.7835 33.9923 17.2115C33.8025 25.3228 27.2669 32.033 19.0878 33V21.6442H23.6521L24.6312 16.5645H19.0878C19.1226 14.4773 18.668 11.8555 21.3386 11.2358C22.2293 11.0289 23.4562 11.0674 24.3841 11.0954C24.5452 11.0999 24.7241 11.158 24.8976 11.1293V6.53508C24.4724 6.45355 24.0448 6.37051 23.615 6.31314C20.5493 5.90399 16.5364 6.03987 14.494 8.64122C12.7311 10.887 12.9031 13.8749 12.9139 16.5645H9.44475C9.44475 16.5645 9.39517 16.6098 9.39517 16.6129V21.5951C9.39517 21.5951 9.44165 21.6434 9.44475 21.6434H12.9139V32.6437C5.84623 30.9376 0.352416 24.7438 0.0666105 17.5678C0.0604142 17.4078 0.0968175 17.2243 0 17.0824V16.0474C0.0929448 15.9161 0.0604142 15.744 0.0666105 15.5945C0.39579 7.2643 7.55022 0.528423 16.0005 0.0324603C16.0833 0.0279309 16.1685 0.0377445 16.2522 0.03397L16.3327 0H17.6936H17.6928Z",
    fill: "#0866FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c35e5be830e551dc137a00c17c748775.svg";
export { ForwardRef as ReactComponent };